export default function service<Service>(name: string, constructor: new () => Service): Service {
  name = name.slice(0, 1).toLocaleLowerCase() + name.slice(1);

  const instance = new constructor();
  if (typeof window !== 'undefined') (window as any)[name] = instance;
  return instance;
}
